import App from '@/App.vue'
import { createApp } from 'vue'
import router from '@/router'
import { createPinia } from 'pinia'

// Loading application components and styles
import loader from './plugins/loader';

window.$ = window.jQuery = require('jquery');

const pinia = createPinia()
// Create vue app
const app = createApp(App)

app.use(loader)
app.use(router)
app.use(pinia)


// Mount vue app
app.mount('#app')

